export { default as ComponentTabs } from "./ComponentTabs";
export * from "./ComponentTabs";
